import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AcceptEmailReplySuggestion as AcceptEmailReplySuggestionMutation,
    AcceptEmailReplySuggestionVariables as AcceptEmailReplySuggestionVariables,
    EmailAcceptSuggestedReplyInput,
} from 'nutshell-graphql-types';

import ACCEPT_EMAIL_REPLY_SUGGESTION from '../mutations/accept-email-reply-suggestion.graphql';

export const useAcceptEmailReplySuggestion = (): {
    acceptEmailReplySuggestion: (arg1: EmailAcceptSuggestedReplyInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [acceptEmailReplySuggestion, {loading, error}] = useMutation<
        AcceptEmailReplySuggestionMutation,
        AcceptEmailReplySuggestionVariables
    >(ACCEPT_EMAIL_REPLY_SUGGESTION);

    return {
        acceptEmailReplySuggestion: (input: EmailAcceptSuggestedReplyInput) =>
            acceptEmailReplySuggestion({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
